<template>
  <div
    class="wrapper"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="$t('connecting')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="page__card">
      <div class="page__card-title">
        <button
          class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl"
          @click="$router.go(-1)"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <p
          v-if="obj.cadastral_number"
          class="rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 leading-snug mr-3"
        >
          {{ obj.cadastral_number }}
        </p>
        <h1 class="mr-2">{{ $t("obj_info") }}</h1>
        <div class="flex items-center flex-wrap gap-2">
          <button
            v-if="!isCreatePage"
            type="button"
            class="bg-indigo-50 hover:bg-indigo-100 py-2 px-4 rounded-xl text-base font-semibold leading-snug text-slate-800 flex items-center gap-2"
            @click="
              $router.push({
                name: 'building-list-one',
                params: { id: $route.params.id, org: state1 },
              })
            "
          >
            {{ $t("building_list") }} <h-eye class="text-indigo-800" />
          </button>
          <button
            v-if="isInfoPage && disabled && me.role.name !== 'supervisor'"
            class="bg-indigo-800 hover:bg-indigo-700 text-white rounded-xl px-4 py-2 flex items-center gap-2"
            type="button"
            @click="disabled = !disabled"
          >
            {{ $t("change") }}
            <h-edit />
          </button>
        </div>
      </div>
      <div class="wp-body" v-if="knumber == 6">
        <div class="">
          <div class="input-section grid gap-4">
            <el-form :model="obj" :rules="rules" ref="obj" class="Form">
              <div class="flex flex-wrap -m-1.5">
                <div class="w-full sm:w-1/2 lg:w-1/3 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("cadaster_number") }}
                  </p>
                  <el-form-item class="mb-0" prop="cadastral_number">
                    <el-input
                      disabled
                      v-model="obj.cadastral_number"
                      :placeholder="`${$t('example')}: 10:01:01:01:01:1111`"
                      clearable
                    />
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 lg:w-1/3 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("transport_table_facility_year") }}
                  </p>
                  <el-form-item class="mb-0" prop="year_construction">
                    <el-date-picker
                      name="year_construction"
                      :disabled="error.date || disabled"
                      :placeholder="$t('transport_table_facility_year')"
                      style="width: 100%"
                      type="year"
                      v-model="obj.year_construction"
                      value-format="yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 lg:w-1/3 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("obj_number_buildings") }}
                  </p>
                  <el-form-item class="mb-0" prop="number_buildings">
                    <el-select
                      name="number_buildings"
                      disabled
                      v-model="obj.number_buildings"
                      :placeholder="$t('obj_number_buildings')"
                      type="number"
                      class="w-full"
                      allow-create
                      filterable
                    >
                      <el-option
                        v-for="item in 100"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div
                  v-if="NewCadasterInfo.cad_number_old"
                  class="w-full sm:w-1/2 lg:w-1/3 p-1.5"
                >
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("object_cadasral_number") }}
                    <span
                      class="bg-indigo-50 px-1 py-0.5 2xl:py-1 2xl:px-2.5 rounded-lg text-indigo-800 font-semibold text-xs 2xl:text-sm whitespace-nowrap"
                    >
                      {{ $t("old_number") }}
                    </span>
                  </p>
                  <el-form-item class="mb-0">
                    <el-input
                      disabled
                      v-model="NewCadasterInfo.cad_number_old"
                      :placeholder="`${$t('example')}: 10:01:01:01:01:1111`"
                      clearable
                    />
                  </el-form-item>
                </div>
                <div
                  class="w-full sm:w-1/2 lg:w-1/3 p-1.5"
                  v-if="role == 'ministry'"
                >
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("object_owner") }}
                  </p>
                  <el-form-item class="mb-0" prop="organization">
                    <el-autocomplete
                      :disabled="disabled"
                      name="organization"
                      class="w-full"
                      valueKey="name_cyr"
                      v-model="state1"
                      :fetch-suggestions="querySearch"
                      :placeholder="$t('object_owner')"
                      @select="handleSelect"
                    ></el-autocomplete>
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 lg:w-1/3 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("date_of_passport") }}
                  </p>
                  <el-form-item class="mb-0" prop="date_of_passport">
                    <el-date-picker
                      name="date_of_passport"
                      disabled
                      v-model="obj.date_of_passport"
                      style="width: 100%"
                      :placeholder="$t('date_of_passport')"
                      type="date"
                      value-format="dd.MM.yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 lg:w-1/3 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("phone") }}
                  </p>
                  <el-form-item class="mb-0" prop="phone">
                    <el-input
                      name="phone"
                      v-mask="'+998 (##) ###-##-##'"
                      :disabled="disabled"
                      v-model="obj.phone"
                      placeholder="+998 (__) ___-__-__"
                      clearable
                    />
                  </el-form-item>
                </div>
                <div class="w-full"></div>
                <div class="w-full sm:w-1/2 md:w-1/4 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("territory") }}
                  </p>
                  <el-form-item class="mb-0" prop="region">
                    <el-select
                      disabled
                      v-model="obj.region"
                      name="object_region"
                      :placeholder="$t('territory')"
                      class="w-full"
                      v-if="parseInt(obj.region) < 16"
                    >
                      <el-option
                        v-for="item in dictionary.region"
                        :key="item.id"
                        :label="item.name_cyr"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-select
                      disabled
                      v-model="obj.region"
                      name="object_region"
                      class="w-full"
                      :placeholder="$t('territory')"
                      v-else
                    >
                      <el-option
                        v-for="item in dictionary.region"
                        :key="item.shared_id"
                        :label="item.name_cyr"
                        :value="item.shared_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 md:w-1/4 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("district") }}
                  </p>
                  <el-form-item class="mb-0" prop="district">
                    <el-input
                      disabled
                      v-if="cadastor_data.district"
                      name="district"
                      :placeholder="$t('district')"
                      v-model="cadastor_data.district"
                    ></el-input>
                    <el-select
                      disabled
                      :loading="loading"
                      name="district"
                      v-model="obj.district"
                      class="w-full"
                      v-else
                    >
                      <el-option
                        v-for="item in current_district"
                        :key="item.shared_id"
                        :label="item.name_cyr"
                        :value="item.shared_id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="w-full sm:w-1/2 md:w-1/4 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("neighborhood") }}
                  </p>
                  <el-input
                    name="object_neigborhood"
                    disabled
                    v-model="obj.neighborhood"
                    :placeholder="$t('neighborhood')"
                    clearable
                  />
                </div>
                <div class="w-full sm:w-1/2 md:w-1/4 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("address") }}
                  </p>
                  <el-form-item class="mb-0" prop="address">
                    <el-input
                      name="address"
                      :disabled="!error.adress"
                      v-model="obj.address"
                      :placeholder="$t('address')"
                      clearable
                    />
                  </el-form-item>
                </div>
                <div class="w-full lg:w-1/2 p-1.5">
                  <div
                    class="bg-slate-50 px-3 py-3.5 rounded-xl flex flex-wrap items-center justify-between"
                    :class="ErrorStatus == 2 ? 'erorr-status' : ''"
                  >
                    <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                      {{ $t("obj_historical_status") }}
                    </p>
                    <template>
                      <el-radio-group
                        v-model="obj.historical_status"
                        :disabled="disabled"
                        class="prime-radio-group"
                      >
                        <el-radio
                          name="obj_historical_status_on"
                          :label="true"
                          border
                        >
                          {{ $t("obj_historical_status_on") }}
                        </el-radio>
                        <el-radio
                          name="obj_historical_status_off"
                          :label="false"
                          border
                        >
                          {{ $t("obj_historical_status_off") }}
                        </el-radio>
                      </el-radio-group>
                    </template>
                    <p v-if="ErrorStatus == 2" style="color:red;">
                      {{ $t("choose") }}
                    </p>
                  </div>
                </div>

                <div class="w-full lg:w-1/2 p-1.5">
                  <p class="font-semibold leading-snug text-slate-800 mb-1.5">
                    {{ $t("geolocation") }}
                  </p>
                  <el-form-item class="mb-0" prop="geolocation">
                    <div class="flex align-top">
                      <el-input
                        @change.native="panToEntered()"
                        name="obj_geolocation"
                        class="flex-1"
                        disabled
                        :placeholder="$t('geolocation')"
                        style="width: 100%"
                        v-model="coor"
                      />
                      <button
                        type="button"
                        v-if="disabled"
                        class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl ml-2 flex items-center justify-center"
                        @click="EditMap(obj.district)"
                      >
                        <h-eye />
                      </button>

                      <ngis-map-modal
                        :cadastral-number="obj.cadastral_number"
                      />

                      <button
                        type="button"
                        v-if="!disabled"
                        class="w-10 h-10 bg-indigo-800 hover:bg-indigo-700 text-white rounded-xl ml-2 flex items-center justify-center"
                        @click="EditMap(obj.district)"
                      >
                        <h-edit />
                      </button>
                    </div>
                  </el-form-item>
                </div>
                <div
                  v-if="
                    !['org_admin', 'ministry_admin', 'main_org_admin'].includes(
                      role,
                    )
                  "
                  class="w-full flex justify-end p-1.5"
                >
                  <div
                    v-if="disabled"
                    class="flex items-center justify-end gap-1 mt-2"
                  >
                    <button
                      v-if="
                        !isCreatePage && ['operator', 'ministry'].includes(role)
                      "
                      type="button"
                      class="add__button"
                      @click="
                        $router.push({
                          name: 'add-build',
                          params: {
                            id: $route.params.id,
                            obj: $route.params.id,
                            cadastral_number: obj.cadastral_number,
                            geo: obj.geolocation,
                          },
                        })
                      "
                    >
                      {{ $t("add_building") }} <h-add-circle />
                    </button>
                  </div>
                  <div v-else class="flex items-center gap-1  justify-end mt-2">
                    <button
                      class="rounded-xl px-4 py-2 ml-2 bg-emerald-500 text-white hover:bg-emerald-600 flex items-center gap-2 font-semibold text-base leading-snug"
                      type="button"
                      @click="save()"
                    >
                      {{ $t("save") }} <h-check-circle />
                    </button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div
        class="fixed-item"
        v-else
        v-loading.fullscreen.lock="loading"
        :element-loading-text="$t('connecting')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="fixed-cover"></div>

        <div class="about-knumber">
          <button class="mt-3">
            <hCircleInfo />
          </button>
          <button class="mt-3">
            <hCircleQuestion />
          </button>
        </div>
        <div
          class="pr bg-white rounded-2xl border border-slate-200 p-4 sm:p-7 max-w-full mx-2"
          style="width: 650px; box-shadow: 0px 4px 15px 0px #0000001A;"
        >
          <p class="text-2xl leading-snug text-slate-950 font-bold mb-5">
            {{ $t("add_new_object") }}
          </p>
          <div class="pb-1.5">
            <span class="font-semibold text-base leading-snug text-slate-800">
              {{ $t("cadaster_number") }}
            </span>
          </div>
          <div class="pb-5">
            <div class="flex items-center gap-2">
              <el-input
                style="min-width:250px;"
                name="cadastral_number"
                class="k-input select_prefix"
                :class="
                  NewCadasterInfo.is_changed
                    ? 'connecting'
                    : knumber == 4 || knumber == 3
                    ? 'succes'
                    : ''
                "
                v-model="cadastral_number"
                placeholder="Мисол: 10:01:01:01:01:1111"
                clearable
                @keyup.enter.native="CheckKadastor()"
              >
                <template slot="prefix">
                  <div class="h-full flex items-center">
                    <icon-number class="text-slate-400 mb-0.5" />
                  </div>
                </template>
              </el-input>
              <button
                class="rounded-xl bg-indigo-800 text-white flex items-center gap-2 font-semibold leading-snug px-2 sm:px-4 py-2"
                @click="CheckKadastor()"
              >
                <span class="hidden sm:inline-block">
                  {{ $t("search_btn") }}
                </span>
                <HSearch />
              </button>
            </div>
            <p
              v-if="inputErrorMessage"
              class="text-sm leading-snug text-rose-600 mt-1.5"
            >
              {{ inputErrorMessage }}
            </p>
            <p
              v-if="knumber == 3"
              class="text-sm leading-snug text-green-400 mt-1.5"
            >
              {{ $t("cadaster_find_uncomplate_data") }}
            </p>
            <p
              v-if="knumber == 4"
              class="text-sm leading-snug text-green-400 mt-1.5"
            >
              {{ $t("cadaster_number_find_succes") }}
            </p>
          </div>
          <!-- <p style="color:#fff">{{a}}</p>  -->
          <div v-if="NewCadasterInfo.is_changed" class="warningk">
            <HWarningError class="w-10 h-10" />
            <p>
              Ушбу объект кадастр рақами янгиланган <br />
              Янги кадастр рақами: <b>{{ NewCadasterInfo.cad_num }}</b>
            </p>
          </div>
          <div class="erorrsk" v-if="errorMessage">
            <HWarningError class="w-10 h-10" />
            <p>{{ errorMessage }}</p>
          </div>
          <div class="uncompletek" v-if="knumber == 3">
            <HWarningError class="w-10 h-10" />
            <p>{{ $t("uncomplate_cadaster_data") }}</p>
          </div>
          <div class="succesk" v-if="knumber == 4">
            <HWarningError class="w-10 h-10" />
            <p>{{ $t("cadaster_number_succes_find") }}</p>
          </div>
          <div class="flex justify-end">
            <button
              class="light-button h-10"
              @click="$router.go(-1)"
            >
              {{ $t("cancel") }}
            </button>
            <button
              class="add__button ml-2 h-10"
              v-if="knumber == 3"
              @click="GoAdd()"
            >
              {{ $t("continue_add") }}
              <HDirectionRight01 />
            </button>
            <button
              class="add__button ml-2 h-10"
              v-if="knumber == 4"
              @click="GoAdd()"
            >
              {{ $t("continue_add") }}
              <HFile01 />
            </button>
          </div>
        </div>
      </div>
      <div v-if="modal" class="modal fs-14" :class="modal ? 'active' : ''">
        <div class="modal-cover"></div>
        <div class="modal-item padding-map" style="width:95%; height:95%;">
          <div class="flex justify-between modal-absolute-header">
            <p class="modal-title ">
              {{ disabled ? `${$t("show_coor")}:` : `${$t("change_coor")}:` }}
            </p>
            <button style="font-size:16px; " @click="modal = false">
              <i class="el-icon-close" style="font-weight:600;"></i>
            </button>
          </div>
          <div class="w-full map-item h-full">
            <yandex-map
              @click="clicked"
              :coords="coords"
              style="height:100%; width: 100%"
              :zoom="14"
              :controls="['zoomControl']"
            >
              <ymap-marker
                :coords="coords"
                marker-id="123"
                hint-content="some hint"
              />
              <button
                v-if="!disabled"
                @click="findMe"
                class="absolute bottom-8 right-2 bg-white h-10 w-10 rounded-xl flex items-center justify-center "
                style="box-shadow: 0 2px 6px 0 rgba(0,0,0,0.2);"
                type="button"
              >
                <IconLocation />
              </button>
            </yandex-map>
          </div>
          <div class="flex w-full justify-between modal-bottom fw-w">
            <div class="modal-inputes flex items-center">
              <p class="flex items-center" style="font-size:16px;">
                <b class="mr-2"> {{ $t("coor") }} :</b> {{ coords.join() }}
              </p>
            </div>
            <div class="flex justify-center items-center">
              <button @click="modal = false" class="light-button h-10">
                {{ $t("close") }}
              </button>
              <button
                v-if="!disabled"
                class="ml-2 add__button"
                @click="SaveEditMap()"
              >
                {{ $t("save") }} <h-check-circle />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapState from "vuex";
import districts from "@/assets/files/districts.json";
import hEye from "../../components/Icons/hEye.vue";
import HEdit from "../../components/Icons/hEdit.vue";
import HCheckCircle from "../../components/Icons/hCheckCircle.vue";
import IconNumber from "@/components/Icons/iconNumber.vue";
import HWarningError from "@/components/Icons/hWarningError.vue";
import HDirectionRight01 from "@/components/Icons/hDirectionRight01.vue";
import HSearch from "@/components/Icons/hSearch.vue";
import HAddCircle from "@/components/Icons/hAddCircle.vue";
import hCircleInfo from "@/components/Icons/hCircleInfo.vue";
import hCircleQuestion from "@/components/Icons/hCircleQuestion.vue";
import HFile01 from "@/components/Icons/hFile01.vue";
import IconLocation from "@/components/Icons/iconLocation.vue";
import NgisMapModal from "@/components/NgisMapModal.vue";

export default {
  components: {
    HFile01,
    hEye,
    HEdit,
    HCheckCircle,
    IconNumber,
    HWarningError,
    HDirectionRight01,
    HSearch,
    HAddCircle,
    hCircleInfo,
    hCircleQuestion,
    IconLocation,
    NgisMapModal,
  },
  data() {
    return {
      errorMessage: "",
      inputErrorMessage: "",
      cadastral_number: "",
      ab: "ss",
      districts: districts,
      modal: false,
      knumber: 0,
      ErrorStatus: 0,
      error: {},
      state1: this.$route.params.org ? this.$route.params.org : "",
      isEditPage: false,
      cadastor_data: {},
      isInfoPage: false,
      isCreatePage: false,
      disabled: false,
      loading: true,
      current_district: [],
      orgList: [],
      search: "",
      orgList2: [],
      coords: [41.31629324503914, 69.26717199864542],
      coor: "",

      obj: {
        // name_uz: "",
        // name_ru: "",
        // name_cyr: "",
        cadastral_number: "",
        year_construction: "",
        region: null,
        district: null,
        address: "",
        // date_of_passport: null,
        phone: "",
        number_buildings: null,
        historical_status: "",
        geolocation: this.Coordes,
        organization: "",
        neighborhood_id: "",
        neighborhood: "",
      },
      rules: {
        organization: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        cadastral_number: [
          {
            required: true,
            message: this.$t("please_add_cadastrel_number"),
            trigger: "change",
          },
          // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
        ],
        year_construction: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
          // { min: 3, max: 5, message: 'Кадастр рақами ', trigger: 'blur' }
        ],
        region: [
          {
            required: true,
            message: this.$t("choose_region"),
            trigger: "change",
          },
        ],
        district: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        date_of_passport: [
          {
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        number_buildings: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        historical_status: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
        geolocation: [
          {
            required: true,
            message: this.$t("please_enter_data"),
            trigger: "change",
          },
        ],
      },
      NewCadasterInfo: {
        cad_num: "",
        is_changed: "",
        cad_number_old: "",
      },
      check_cad_number: "",
    };
  },
  mounted() {
    if (this.$route.name === "obj-info") {
      this.disabled = true;
      this.isInfoPage = true;
    } else if (this.$route.name === "obj-update") {
      this.isEditPage = true;
    }

    if (this.$route.name !== "obj-create") {
      this.knumber = 6;
      axios
        .get(`/building/generalinformation/${this.$route.params.id}/`)
        .then((response) => {
          console.log(response);
          if (response.data.cadastral_number_old) {
            this.NewCadasterInfo.cad_number_old =
              response.data.cadastral_number_old;
          }
          this.obj = response.data;
          this.coor = this.obj.geolocation.join();
          this.initialCoords = response.data.geolocation;
          this.coords = response.data.geolocation;
          this.obj.year_construction = String(response.data.year_construction);
          // this.obj.geolocation = JSON.parse(response.data.geolocation);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.isCreatePage = true;
      this.loading = false;
    }
  },
  computed: {
    dictionary() {
      return this.$store.state.dictionary;
    },
    Coordes() {
      return this.$store.state.Coord;
    },
    me() {
      return this.$store.state.me;
    },
    role() {
      return this.$store.state.role;
    },
  },
  watch: {
    "obj.historical_status"() {
      if (this.obj.historical_status != "") {
        this.ErrorStatus = 0;
      }
    },
  },
  methods: {
    findMe() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.coords = [position.coords.latitude, position.coords.longitude];
            this.zoom = 14;
          },
          (error) => {
            console.error("Joylashuv aniqlanmadi:", error.message);
            alert("Joylashuvingizni aniqlash uchun ruxsat bering!");
          },
        );
      } else {
        alert("Sizning brauzeringiz geolokatsiyani qo‘llamaydi 😕");
      }
    },
    // Keremas
    querySearch(queryString, cb) {
      axios
        .get(`/organization/?limit=200&search=${queryString}`)
        .then((response) => {
          cb(response.data.results);
        });
    },
    createFilter() {
      return (link) => {
        return link.name_cyr;
      };
    },
    handleSelect(item) {
      this.obj.organization = item.id;
    },

    //   Keremas
    goBack() {
      // window.history.back();
      this.$router.go(-1);
    },
    regionChanged() {
      this.obj.district = "";
      this.current_district = [];
      this.getDistrict();
    },

    EditMap(id) {
      this.modal = true;
      if (this.coor) {
        this.coords = this.coor.split(",");
      } else {
        this.coords = this.districts[`${id}`].coor;
      }
    },
    SaveEditMap() {
      this.modal = false;
      this.coor = this.coords.join();
      this.obj.geolocation = this.coords;
    },
    clicked(e) {
      if (this.disabled) {
        this.coords = e.get("coords");
      }
    },
    save() {
      // this.obj.geolocation = this.obj.geolocation ? JSON.stringify(this.obj.geolocation) : this.obj.geolocation;
      this.$refs.obj.validate((valid) => {
        if (valid) {
          if (this.obj.historical_status !== "") {
            this.loading = true;
            if (this.isInfoPage || this.isEditPage) {
              axios
                .patch(
                  `/building/generalinformation/${this.$route.params.id}/`,
                  this.obj,
                )
                .then((response) => {
                  this.$swal.fire({
                    icon: "success",
                    title: this.$t("data_saved"),
                    timer: 3000,
                  });
                  this.goBack();
                })
                .catch((error) => {
                  this.$swal.fire({
                    icon: "error",
                    title: this.$t("error_save"),
                    timer: 3000,
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
            } else {
              axios
                .post("/building/generalinformation/", this.obj)
                .then((response) => {
                  this.$swal.fire({
                    icon: "success",
                    title: this.$t("data_saved"),
                    timer: 3000,
                  });

                  this.goBack();
                })
                .catch((error) => {
                  if (
                    error.response &&
                    error.response.status === 400 &&
                    error.response.data?.cadastral_number?.includes(
                      "This field must be unique.",
                    )
                  ) {
                    this.$swal.fire({
                      icon: "error",
                      title: this.$t("cadastral_number_exists"),
                      timer: 3000,
                    });
                    return;
                  }

                  this.$swal.fire({
                    icon: "error",
                    title: this.$t("error_save"),
                    timer: 3000,
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
            }
            this.ErrorStatus = 1;
          } else {
            this.ErrorStatus = 2;
          }
        }
      });
    },
    SearchAll(queryString, cb) {
      var a = "";
      axios.get(`/organization/?search=${queryString}`).then((response) => {
        a = response.data.results;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(a);
        }, 3000 * Math.random());
      });
    },
    panToFirst() {
      this.coords = this.initialCoords;
    },
    panToEntered(e) {
      // this.coords = this.obj.geolocation.split(",");
    },
    clicked(e) {
      if (!this.disabled) this.coords = e.get("coords");
    },
    CheckKadastor() {
      this.inputErrorMessage = "";
      this.knumber = 0;
      this.NewCadasterInfo = {
        cad_num: "",
        is_changed: "",
        cad_number_old: "",
      };
      const cadastralNumber = this.cadastral_number.replaceAll(" ", "");
      if (cadastralNumber.length < 19) {
        this.inputErrorMessage = "Кадастр рақами нотўғри киритилган";
      } else {
        this.loading = true;
        this.errorMessage = "";
        axios
          .post(`/building/check_cadastral_number/`, {
            cadastral_number: cadastralNumber,
          })
          .then(() => {
            axios
              .post("/dictionary/insert/cadastr/", {
                type: "cadastr",
                cad_num: cadastralNumber,
              })
              .then((res) => {
                this.a = res.data.result;
                if (res.data.is_changed) {
                  this.NewCadasterInfo.is_changed = res.data.is_changed;
                  this.NewCadasterInfo.cad_num = res.data.cad_number;
                  this.NewCadasterInfo.cad_number_old = res.data.cad_number_old;
                }

                this.cadastor_data = res.data;
                // Street
                if (res.data.address) {
                  var address = res.data.address.split(",");
                  if (address.length > 3) {
                    this.obj.address = address[0] + address[1];
                  } else {
                    address = res.data.address.split(",");
                    if (address.length > 2) {
                      this.obj.address = address[0] + address[1];
                    } else {
                      this.obj.address = res.data.address;
                    }
                  }
                  this.error.adress = false;
                } else {
                  this.error.adress = true;
                }
                this.obj.cadastral_number = cadastralNumber;
                // Region
                this.obj.region = res.data.region_id;
                // District
                if (this.obj.region) {
                  axios
                    .get(
                      `/dictionary/district/?region__shared_id=${this.obj.region}`,
                    )
                    .then((response) => {
                      this.current_district = response.data;
                      this.obj.district = res.data.district_id;
                    });
                  this.error.region = false;
                } else {
                  this.error.region = false;
                }
                // neighbordhood
                if (res.data.neighborhood_id) {
                  this.obj.neighborhood_id = res.data.neighborhood_id;
                  this.obj.neighborhood = res.data.neighborhood;
                }
                // number_buildings
                if (res.data.objects_count) {
                  this.obj.number_buildings = parseInt(res.data.objects_count);
                } else {
                  this.obj.number_buildings = 0;
                }

                // date building
                if (res.data.year) {
                  var date = res.data.year.split(".");
                  if (date.length > 1) {
                    this.obj.year_construction = date[2];
                  } else {
                    date = res.data.year.split("-");
                    this.obj.year_construction = date[0];
                  }
                  this.error.date = true;
                } else {
                  this.error.date = false;
                }
                this.knumber = 4;
                if (!this.error.date) {
                  this.knumber = 3;
                }
                this.loading = false;
              })
              .catch((e) => {
                this.loading = false;
                if (e.response) {
                  if (e.response.status == 500) {
                    this.errorMessage = this.$t("error_ser");
                  } else {
                    this.errorMessage =
                      e.response.data?.message ||
                      e.response.status + " Хатолик юз берди";
                  }
                } else {
                  this.errorMessage = this.$t("error_with_cadaster_server");
                }
              });
          })
          .catch((e) => {
            this.loading = false;
            if (e.response) {
              if (e.response.status == 500) {
                this.errorMessage = this.$t("error_ser");
              } else {
                this.errorMessage =
                  e.response.data?.detail ||
                  e.response.status + "Хатолик юз берди";
              }
            } else {
              this.errorMessage =
                "Хатолик юз берди. Илтимос, қайта уриниб кўринг.";
            }
          });
      }
    },
    GoAdd() {
      this.knumber = 6;
      if (this.NewCadasterInfo.is_changed) {
        this.obj.cadastral_number = this.NewCadasterInfo.cad_num;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg10 {
  background: rgb(2, 177, 2);
}

.demo-ruleForm {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.actions {
  margin-top: 40px;

  .el-button {
    width: 100%;
    margin: 0;
    margin-bottom: 15px;
  }

  .primary {
    display: flex;
    justify-content: space-between;

    .el-button {
      width: calc(50% - 7.5px);
    }
  }
}

.title-second-header {
  font-size: 18px;
  font-weight: 600;
  color: #43abba !important;
}

.map-item {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}
</style>
